import { Injectable } from '@angular/core';

import { FsApi, RequestConfig } from '@firestitch/api';

import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CommentData {
  constructor(private _fsApi: FsApi) {
  }

  public get(commentId, query = {}): Observable<any> {
    return this._fsApi.get(`comments/${commentId}`, query, { key: 'comment' });
  }

  public gets(data = {}, config: RequestConfig = {}): Observable<any> {
    return this._fsApi.request('GET', 'comments', data, { key: 'comments', ...config });
  }

  public put(comment, config: RequestConfig = {}): Observable<any> {
    return this._fsApi.put(`comments/${comment.id}`, comment, { key: 'comment', ...config });
  }

  public post(comment): Observable<any> {
    return this._fsApi.post(`comments/tasks/${comment.objectId}`, { content: comment.content }, { key: 'comment' });
  }

  public delete(data, type): Observable<any> {
    return this._fsApi.delete(`comments/${type}/${data.objectId}/${data.comment.id}`, data.comment, { key: 'comment' });
  }

  public save(data): Observable<any> {
    if (data.id) {
      return this.put(data);
    }

    return this.post(data);
  }

}
